import React from 'react'

import * as Form from 'modules/plan/components/Form'
import * as Layout from '../Layout/Section'

import * as styles from './styles.module.scss'

/**
 */
export const SelectProperty = () => (
  <Layout.Container>
    <Layout.Title>Floor Plan</Layout.Title>
    <Layout.Description>お部屋の形状をお選びください。</Layout.Description>
    <Layout.Content>
      <Form.Fields.Property />
    </Layout.Content>
  </Layout.Container>
)
